(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

const userAgent = navigator.userAgent;
const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
if (mobileRegex.test(userAgent)) {
    document.querySelector("a[href='/pages/help-center']").classList.add("atlas_help_center_mobile")
} else {
    document.querySelector("a[href='/pages/help-center']").classList.add("atlas_help_center_desktop")
}

const help_center_link = document.querySelector("a[href='/pages/help-center']");
if (help_center_link) {
  help_center_link.addEventListener("click", function () {
    if(this.classList.contains("atlas_help_center_mobile")){
      gtag('event', 'atlas_mobile_help_center_tracking');
    }else if (this.classList.contains("atlas_help_center_desktop")){
      gtag('event', 'atlas_desktop_help_center_tracking');
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-cards"] && !Shopify.designMode) return;
  try {
    
    document.querySelectorAll('.cn_atlas_promo_card_item').forEach(card => {
        card.addEventListener('click', function(e) {
            // Prevent triggering when button clicked
            if (e.target.closest('a')) return;

            const link = this.dataset.link;
            const target = this.dataset.target;

            if (!link) return;

            if (target == "true") {
                window.open(link, '_blank');
            } else {
                window.location.href = link;
            }
        });
    });

  } catch(e) { console.error(e); }
})();
})();
